import { downloadObjectsAsCsv } from '@/utils/csv/csvObject'

/**
 * ヘッダー行のみのテンプレートCSVをブラウザにダウンロードさせる（#4728）。
 * データ行を持たない書き出しは既存の共有CSVユーティリティ（downloadObjectsAsCsv、
 * マスタ系17画面のCSVエクスポートで使用中）を rows=[] で再利用する
 * （CSVエスケープ・BOM付与を再発明しない）。
 */
export const downloadCsvTemplate = (
  filename: string,
  headers: string[]
): void => {
  downloadObjectsAsCsv<Record<string, unknown>>(filename, [], {
    keyOrder: headers,
    bom: true
  })
}
